import { getTheme } from 'src/utils/get-theme';

import { StaffCategory, Subject } from './form-options';

const { isHosTheme } = getTheme();

export const SUBJECT_TRANSLATION_KEY: Record<Subject, string> = {
    [Subject.Events]: 'feedback_page_events',
    [Subject.Breakfast]: 'feedback_page_breakfast',
    [Subject.HouseKeeping]: 'feedback_page_housekeeping',
    [Subject.Maintenance]: 'feedback_page_maintenance',
    [Subject.Staff]: 'feedback_page_staff',
    [Subject.HealthAndSafety]: 'feedback_page_health-safety',
    [Subject.Wifi]: 'feedback_page_wifi',
    [Subject.EverythingElse]: 'feedback_page_everything-else',
};

export const SUBJECT_TITLE_TRANSLATION_KEY: Record<Subject, string> = {
    [Subject.Events]: 'feedback_page_events_title',
    [Subject.Breakfast]: 'feedback_page_breakfast_title',
    [Subject.HouseKeeping]: 'feedback_page_housekeeping_title',
    [Subject.Maintenance]: 'feedback_page_maintenance_title',
    [Subject.Staff]: 'feedback_page_staff_title',
    [Subject.HealthAndSafety]: 'feedback_page_health-safety_title',
    [Subject.Wifi]: 'feedback_page_wifi_title',
    [Subject.EverythingElse]: 'feedback_page_everything-else_title',
};

export const SUBJECT_RATING_TITLE_TRANSLATION_KEY: Record<Subject, string> = {
    [Subject.Events]: 'feedback_page_events_rating_title',
    [Subject.Breakfast]: 'feedback_page_breakfast_rating_title',
    [Subject.HouseKeeping]: 'feedback_page_housekeeping_rating_title',
    [Subject.Maintenance]: 'feedback_page_maintenance_rating_title',
    [Subject.Staff]: 'feedback_page_staff_rating_title',
    [Subject.HealthAndSafety]: isHosTheme
        ? 'feedback_page_health-safety_rating_title_hos'
        : 'feedback_page_health-safety_rating_title_vs',
    [Subject.Wifi]: 'feedback_page_wifi_rating_title',
    [Subject.EverythingElse]: 'feedback_page_everything-else_rating_title',
};

export const STAFF_CATEGORY_TRANSLATION_KEY: Record<StaffCategory, string> = {
    [StaffCategory.DayTeam]: 'feedback_page_select-staff_day-team',
    [StaffCategory.NightTeam]: 'feedback_page_select-staff_night-team',
    [StaffCategory.Housekeepers]: 'feedback_page_select-staff_housekeepers',
    [StaffCategory.Management]: 'feedback_page_select-staff_management',
    [StaffCategory.Maintenance]: 'feedback_page_select-staff_maintenance',
};

export const SUBJECT_SUBCATEGORY_TRANSLATION_KEY: Partial<Record<Subject, Record<string, string>>> =
    {
        [Subject.Breakfast]: {
            service: 'feedback_page_breakfast_subcategory_service',
            menu: 'feedback_page_breakfast_subcategory_menu',
            other: 'feedback_page_breakfast_subcategory_other',
        },
        [Subject.HouseKeeping]: {
            'missed-housekeeping-service': 'feedback_page_housekeeping_subcategory_service',
            'housekeeping-standards': 'feedback_page_housekeeping_subcategory_standards',
            other: 'feedback_page_housekeeping_subcategory_other',
        },
        [Subject.Maintenance]: {
            water: 'feedback_page_maintenance_subcategory_water',
            electrical: 'feedback_page_maintenance_subcategory_electrical',
            'room-access': 'feedback_page_maintenance_subcategory_room-access',
            furniture: 'feedback_page_maintenance_subcategory_furniture',
            appliances: 'feedback_page_maintenance_subcategory_appliances',
        },
        [Subject.HealthAndSafety]: {
            security: 'feedback_page_health-safety_subcategory_security',
            'cleanliness-and-pests': 'feedback_page_health-safety_subcategory_cleanliness-pests',
            smoking: 'feedback_page_health-safety_subcategory_smoking',
            'noises-and-disturbances':
                'feedback_page_health-safety_subcategory_noises-disturbances',
            other: 'feedback_page_health-safety_subcategory_other',
        },
        [Subject.Wifi]: {
            speed: 'feedback_page_wifi_subcategory_speed',
            connectivity: 'feedback_page_wifi_subcategory_connectivity',
            other: 'feedback_page_wifi_subcategory_other',
        },
        [Subject.EverythingElse]: {
            'parcel-store': 'feedback_page_everything-else_subcategory_parcel-store',
            'laundry-room': 'feedback_page_everything-else_subcategory_laundry-room',
            'payments-and-my-contract':
                'feedback_page_everything-else_subcategory_payments-contract',
            'sales-team': 'feedback_page_everything-else_subcategory_sales-team',
            'customer-engagement-team':
                'feedback_page_everything-else_subcategory_customer-engagement-team',
            'communal-spaces': 'feedback_page_everything-else_subcategory_communal-spaces',
        },
    };
